import { Button, Grid, Typography, useTheme } from '@mui/material';
import OrganizationAccountForm from '../../components/organization/OrganizationAccountForm';
import React, { useState } from 'react';
import { DocumentNode, useMutation } from '@apollo/client';
import { createOrganizationAccount } from 'vendor-marketplace-shared-library/compiled/graphql/procure/procure-queries.graphql';
import useAlert from '../../hooks/useAlert';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export default function CreateOrganizationPage() {
  const alert = useAlert();
  const { userQuery, logout } = useAuth();
  const theme = useTheme();
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);

  const [createOrganization] = useMutation(createOrganizationAccount, {
    refetchQueries: ['me'],
    onCompleted: async () => {
      setLoading(false);
      await userQuery.refetch();
    },
    onError: () => {
      alert.setAlert({ severity: 'error', message: 'CREATE_ORGANIZATION_ACCOUNT' });
      setLoading(false);
    },
  });

  const onCreate = async (formData: { name: string }) => {
    setLoading(true);
    await createOrganization({
      variables: {
        input: {
          name: formData.name,
        },
      },
    });
  };

  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item>
        <Grid
          container
          sx={[{ border: `1px ${theme.palette.secondary.light} solid` }, styles.card]}
        >
          <Grid item>
            <img height={75} width={200} src={'procure-logo-black.png'} alt={'logo'} />
          </Grid>
          <Grid item>
            <Typography variant={'h6'}>Create an organization</Typography>
          </Grid>
          <Grid item>
            <OrganizationAccountForm
              loading={loading}
              onSubmit={onCreate}
              organization={userQuery.data?.me.organizationAccount || ''}
            />
          </Grid>

          <Grid item>
            <Grid container sx={styles.subContainer}>
              <Grid item>
                <Typography variant={'caption'}>Already have an account?</Typography>
              </Grid>
              <Grid item>
                <Button
                  size='small'
                  onClick={() => {
                    logout();
                    navigation('/login');
                  }}
                >
                  Sign in
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    height: '100vh',
  },
  card: {
    maxWidth: '650px',
    minWidth: '320px',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: 2,
    paddingTop: 6,
    paddingBottom: 6,
    rowGap: 4,
    flex: 1,
  },
  subContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: 1,
  },
};
